<template>
    <div class="customer-customer-actions-msp">
        <v-layout wrap mb-2>
            <v-flex md12>
                <v-btn
                    outlined
                    block
                    color="success"
                    :loading="inAction"
                    :disabled="loading || inAction || !valid"
                    @click="showDialog = true"
                >
                    Kunden übertragen
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout wrap mb-2>
            <v-flex md12>
                <v-btn
                    outlined
                    color="warning"
                    block
                    @click="abort"
                    :disabled="inAction || loading"
                >
                    Abbrechen
                </v-btn>
            </v-flex>
        </v-layout>

        <v-dialog
            v-model="showDialog"
            max-width="500"
            persistent
        >
            <v-card>
                <v-card-title class="headline">Übertragung</v-card-title>
                <v-card-text>
                    Soll nach der erfolgreichen Übertragung der Daten eine
                    Bestätigungsmail an den Kunden versendet werden?

                    <v-switch
                        :label="sendMailing ? 'E-Mail versenden' : 'E-Mail nicht versenden'"
                        v-model="sendMailing"
                        @change="setSendMailing"
                    ></v-switch>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="warning"
                        outlined
                        @click="abortDialog"
                    >Abbrechen</v-btn>

                    <v-btn
                        color="success"
                        outlined
                        @click="submitForm"
                    >Übertragen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {
    mapActions,
    mapMutations,
    mapState,
} from 'vuex';
import Route from '@/route';

export default {
    name: 'CustomerActionsMsp',
    data() {
        return {
            showDialog: false,
        };
    },
    computed: {
        ...mapState('customerMsp', [
            'loading',
            'inAction',
            'valid',
            'ssoId',
            'scope',
            'sendMailing',
        ]),
    },
    methods: {
        ...mapActions('customerMsp', ['submit']),
        ...mapMutations('customerMsp', [
            'setSendMailing',
        ]),
        abort() {
            this.$router.push({
                name: Route.SEARCH.name,
            });
        },
        submitForm() {
            this.showDialog = false;
            this.submit().then(() => {
                this.$router.push({ name: Route.CUSTOMER_C1.name, params: { sso_id: this.ssoId } });
            }).catch(() => null);
        },
        abortDialog() {
            this.showDialog = false;
        },
    },
};

</script>
<style scoped lang="scss"></style>
